import type { FlattenSimpleInterpolation } from 'styled-components'
import styled from 'styled-components'

import ListItem from '@vfuk/core-list-item'
import Interaction from '@vfuk/core-interaction'

export const UserIcon = styled(ListItem)((): FlattenSimpleInterpolation => [])

export const UserLink = styled(Interaction)((): FlattenSimpleInterpolation => [])
